import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantCashTransferServiceSharedService } from '../../services/wealthlane-award-settlement-services';

const useGetCashTransferCancelStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const cashTransferCancelStatus = useQuery(
    ['getCashTransferCancelStatus'],
    async () => {
      return await handleRequest(
        ParticipantCashTransferServiceSharedService.getApiAwardSettlementApiAppParticipantCashTransferServiceCashTransferCancelStatus()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return cashTransferCancelStatus;
};

export default useGetCashTransferCancelStatus;
